import { useState, useCallback } from 'react';
import { useRecoilValue } from 'recoil';
import { interveneUserDetailAtom } from '../state/interveneAtoms';

export default function useInterveneHeaderActions() {
  const activeUser = useRecoilValue(interveneUserDetailAtom);

  const [callDialogOpen, setCallDialogOpen] = useState(false);
  const [templateDialogOpen, setTemplateDialogOpen] = useState(false);

  const openCallDialog = useCallback(() => {
    if (!activeUser?.phone_number) return;
    setCallDialogOpen(true);
  }, [activeUser?.phone_number]);

  const openTemplateDialog = useCallback(() => {
    if (!activeUser?.phone_number) return;
    setTemplateDialogOpen(true);
  }, [activeUser?.phone_number]);

  const closeCallDialog = useCallback(() => setCallDialogOpen(false), []);
  const closeTemplateDialog = useCallback(() => setTemplateDialogOpen(false), []);

  return {
    callDialogOpen,
    templateDialogOpen,
    openCallDialog,
    openTemplateDialog,
    closeCallDialog,
    closeTemplateDialog,
  };
}
